(function () {
  'use strict';

  function init(root) {
    var openButton = root.querySelector('[data-imhdr-open]');
    var closeButton = root.querySelector('[data-imhdr-close]');
    var drawer = root.querySelector('[data-imhdr-drawer]');
    var scrim = root.querySelector('[data-imhdr-scrim]');
    var lastFocus = null;
    var previousOverflow = '';
    var inertTargets = Array.prototype.slice.call(document.querySelectorAll('main, footer'));

    if (!openButton || !closeButton || !drawer || !scrim) return;

    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-hidden', 'true');

    function focusableElements() {
      return Array.prototype.slice.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return !element.hidden && element.getClientRects().length > 0;
      });
    }

    function setOutsideInert(value) {
      inertTargets.forEach(function (element) {
        if ('inert' in element) element.inert = value;
      });
    }

    function openMenu() {
      if (!drawer.hidden) return;
      lastFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      drawer.hidden = false;
      scrim.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      setOutsideInert(true);

      var firstTarget = focusableElements()[0] || closeButton;
      window.requestAnimationFrame(function () {
        firstTarget.focus();
      });
    }

    function closeMenu() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      scrim.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = previousOverflow;
      setOutsideInert(false);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function trapFocus(event) {
      if (drawer.hidden || event.key !== 'Tab') return;
      var focusables = focusableElements();
      if (!focusables.length) {
        event.preventDefault();
        closeButton.focus();
        return;
      }

      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', closeMenu);
    scrim.addEventListener('click', closeMenu);
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) {
        event.preventDefault();
        closeMenu();
        return;
      }
      trapFocus(event);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1120 && !drawer.hidden) closeMenu();
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-imhdr]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
